// Open External Links in new tabs

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

// End Open External Links in new tab

// Gift Menu hover effect.

$('.gifts .has-sub-dropdown').hover(function() {
  $(this).parent().find('li:not(.sub-dropdown-item) > a').toggleClass('opacity')
})
// Cart Form Price Away from Shipping

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}


function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}     

// Notices on Cart Black Friday and Free shipping

$('.main-carousel').flickity({
  cellAlign: "left",
  contain: true,
  imagesLoaded: true,
  lazyLoad: true,
  pageDots: false,
  wrapAround: true
});

$(document).ready(function() {
  getCartandUpdate()
});

function getCartandUpdate() {
  console.log('get_cart_update')
  jQuery
  .ajax({
    url: "/cart.js",
    dataType: "json"
  })
  .done(function(data) {
    updateCartNotices(data.items_subtotal_price);
  });
}

function updateCartNotices(cartprice) {
  console.log(cartprice)
  if (1 < cartprice && cartprice < 7500) {
    console.log( "< 75")
    var value = (7500 - cartprice) / 100;
    var sentence =
      "Spend $" + value + " to reach $75 & qualify for free shipping";
    $("#cartNotice").text(sentence);
    $("#cartNotice").show();

    $("#money-left").text(value)
    $('.to-free-shipping').show()
  }
  else {
    $("#cartNotice").hide();
    $('.to-free-shipping').hide();
  }
}

// End Cart Awaya from Price

/* Blog sidebar button */
function sidebarMenu(){
  const sidebarElement = document.getElementById('blog-sidebar');
  sidebarElement.classList.toggle('show');
}
const blogsearch = document.getElementById('btn-blogsearch');
if(blogsearch !== null){
  blogsearch.addEventListener("click", function(){
    this.closest('form').submit();
  });
}


/* Mobile Menu */

const mobile_open = document.querySelectorAll('.drawer-menu__list-item > disclosure-menu > details > summary > div > .mobile-nav-el');
const account_menu = document.querySelector('.menu-drawer__account');
const customer_menu = document.querySelector('.nav-costumer');
const modal_close = document.querySelector('.mobile-close');
const main_menu = document.querySelector('.menu-drawer__navigation');
mobile_open.forEach((element) => {
  element.addEventListener('click', function(e){
    let li = e.target.closest('ul').querySelectorAll('li');
    let parentEl = e.target.closest('details[open]');
    if(parentEl !== null) {
      li.forEach((e) => {
        e.classList.remove('hide');
        account_menu.classList.remove('hide');
        customer_menu.classList.remove('hide');
        modal_close.classList.remove('hide');
        main_menu.classList.remove('hide');
      });
    } else {
      li.forEach((e) => {
        e.classList.add('hide');
        account_menu.classList.add('hide');
        customer_menu.classList.add('hide');
        modal_close.classList.add('hide'); 
        main_menu.classList.add('hide');
      });
      e.target.closest('li').classList.remove('hide');
    }
  }); 
}); 